import instance from "./instance";
export const uploadfile = (data) => instance({
    method: "post",
    url: "/api/common/uploadfile",
    data,
    
})
export const register = (data) => instance({
    method: "post",
    url: "/api/moyi.user/register",
    data,
    
})
export const login = (data) => instance({
    method: "post",
    url: "/api/moyi.user/login",
    data,
    
})
export const changePassword = (data) => instance({
    method: "post",
    url: "/api/moyi.user/changePassword",
    data,
    
})
export const pageinfo = (data) => instance({
    method: "post",
    url: "/api/yixue/pageinfo",
    data,
    
})
export const editProfile = (data) => instance({
    method: "post",
    url: "/api/moyi.user/editProfile",
    data,
    
})
export const refreshUser = (data) => instance({
    method: "post",
    url: "/api/moyi.user/refreshUser",
    data,
    
})
export const logout = (data) => instance({
    method: "post",
    url: "/api/moyi.user/logout",
    data,
    
})
export const findPasswordByEmail = (data) => instance({
    method: "post",
    url: "/api/yixue/findPasswordByEmail",
    data,
    
})
export const setPasswordByEmail = (data) => instance({
    method: "post",
    url: "/api/yixue/setPasswordByEmail",
    data,
    
})
export const indexConfig = (data) => instance({
    method: "post",
    url: "/api/yixue/indexConfig",
    data,
    
})
export const getYjsjlxList = (data) => instance({
    method: "post",
    url: "/api/yixue/getYjsjlxList",
    data,
    
})
export const getBzflList = (data) => instance({
    method: "post",
    url: "/api/yixue/getBzflList",
    data,
    
})

export const getBzflListTree = (data) => instance({
    method: "post",
    url: "/api/yixue/getBzflListTree",
    data,
    
})
export const getMklistTree = (data) => instance({
    method: "post",
    url: "/api/yixue/getMklistTree",
    data,
    
})
export const createOrder = (data) => instance({
    method: "post",
    url: "/api/yixue/createOrder",
    data,
    
})
export const getOrderList = (data) => instance({
    method: "post",
    url: "/api/yixue/getOrderList",
    data,
    
})
export const getOrderInfo = (data) => instance({
    method: "post",
    url: "/api/yixue/getOrderInfo",
    data,
    
})
export const payOrder = (data) => instance({
    method: "post",
    url: "/api/yixue/payOrder",
    data,
    
})
export const checkOrderPay = (data) => instance({
    method: "post",
    url: "/api/yixue/checkOrderPay",
    data,
    
})
export const payOrderYuer = (data) => instance({
    method: "post",
    url: "/api/yixue/payOrderYuer",
    data,
    
})
export const getFapiaoList = (data) => instance({
    method: "post",
    url: "/api/yixue/getFapiaoList",
    data,
    
})
export const orderkaipiao = (data) => instance({
    method: "post",
    url: "/api/yixue/orderkaipiao",
    data,
    
})
export const orderEdit = (data) => instance({
    method: "post",
    url: "/api/yixue/orderEdit",
    data,
    
})
export const orderOutWord = (data) => instance({
    method: "post",
    url: "/api/yixue/orderOutWord",
    data,
    
})
export const getconfig = (data) => instance({
    method: "post",
    url: "/api/yixue/getconfig",
    data,
    
})

// responseType: 'blob',